<template>
  <div>
    <alerta
      v-on:fecharModal="fecharModal"
      :exibir="modal.exibir"
      :titulo="modal.titulo"
      :mensagem="modal.mensagem"
    />

    <div>
      <!-- Barra Principal -->
      <v-app-bar color="#278B97" height="84" class="hidden-sm-and-down">
        <v-container class="container-appbar">
          <v-row class="row-principal-appbar">
            <!-- Botões + Bem-vindo -->
            <v-col cols="3" md="4" lg="3">
              <v-toolbar-title class="toolbar">
                <!-- Notificações -->
                <v-menu
                  v-model="menuPendencias"
                  offset-y
                  max-width="352"
                  allow-overflow
                  max-height="300"
                  v-dropdown-acessivel="{ tipo: 'menu', rotulo: 'Pendências' }"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="botao-header"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      :aria-label="rotuloPendencias"
                    >
                      <v-icon>fa-solid fa-bell</v-icon>
                      <span v-if="totalPendencias" class="notificacao">{{
                        totalPendencias
                      }}</span>
                    </v-btn>
                  </template>

                  <v-list
                    ref="pendenciasDesktop"
                    :three-line="listaPendencias.length > 0"
                    @keydown.native="navegarPendencias"
                  >
                    <template v-if="listaPendencias.length">
                      <v-subheader>Pendências</v-subheader>
                      <v-list-item
                        v-for="(item, index) in listaPendencias"
                        :key="index"
                        @click="abrirPendencia(item)"
                        role="menuitem"
                      >
                        <v-list-item-content>
                          <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                          <v-list-item-subtitle>{{ item.descricao }}<span v-if="item.externo" class="sr-only">, abre em nova aba</span></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <v-list-item v-else>
                      <v-list-item-content>
                        <v-list-item-title>Você não possui pendências no momento.</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <!-- Home -->
                <v-btn
                  to="/"
                  class="botao-header"
                  dark
                  aria-label="Pagina inicial"
                >
                  <v-icon>fa-solid fa-house</v-icon>
                </v-btn>

                <!-- Bem-vindo -->
                <div class="containerBemVindo">
                  <p class="bemVindo">BEM-VINDO</p>
                  <p class="nomeUsuario">{{ nomeSobrenome() }}</p>
                  <button type="button" class="sair" @click="logout()">
                    Sair
                  </button>
                </div>
              </v-toolbar-title>
            </v-col>

            <!-- Pesquisar -->
            <v-col cols="6" md="4" lg="6">
              <v-row role="search">
                <v-text-field
                  @keyup.enter="buscar()"
                  aria-label="Pesquisar no Nossa Hepta"
                  class="pesquisa"
                  hide-details="auto"
                  dense
                  flat
                  solo
                  v-model="keyword"
                  clearable
                >
                  <template slot="label">
                    <span class="pesquisa-label">Pesquisar</span>
                  </template>
                </v-text-field>
                <v-btn
                  @click="buscar()"
                  class="pesquisa-btn"
                  aria-label="Pesquisar"
                >
                  <v-icon>fa-solid fa-magnifying-glass</v-icon>
                </v-btn>
              </v-row>
            </v-col>

            <!-- Espaço do Colaborador -->
            <v-col cols="3" md="4" lg="3" class="text-right">
              <v-btn
                to="/espaco-do-colaborador"
                class="botao-espaco-colaborador"
                color="#32ACB9"
                >Espaço do Colaborador</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-app-bar>

      <!-- Barra Mobile -->
      <div class="topbar-mobile hidden-md-and-up">
        <v-container>
          <v-row class="toolbar-mobile">
            <!-- Botões Principais -->
            <v-col cols="2">
              <v-app-bar-nav-icon
                @click.stop="sidebar = !sidebar"
                variant="text"
                color="white"
                aria-label="Abrir menu de navegacao"
                :aria-expanded="String(sidebar)"
              />
            </v-col>
            <v-col cols="6">
              <img
                src="../assets/images/espaco-colaborador/logo_nossa_hepta.png"
                alt="Nossa Hepta"
              />
            </v-col>
            <v-col cols="2">
              <v-menu
                v-model="menuPendenciasMobile"
                offset-y
                max-width="352"
                allow-overflow
                max-height="300"
                v-dropdown-acessivel="{ tipo: 'menu', rotulo: 'Pendências' }"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    dark
                    v-bind="attrs"
                    v-on="on"
                    :aria-label="rotuloPendencias"
                  >
                    <v-icon>fa-solid fa-bell</v-icon>
                    <span v-if="totalPendencias" class="notificacao">{{
                      totalPendencias
                    }}</span>
                  </v-btn>
                </template>

                <v-list
                  ref="pendenciasMobile"
                  :three-line="listaPendencias.length > 0"
                  @keydown.native="navegarPendencias"
                >
                  <template v-if="listaPendencias.length">
                    <v-subheader>Pendências</v-subheader>
                    <v-list-item
                      v-for="(item, index) in listaPendencias"
                      :key="index"
                      @click="abrirPendencia(item)"
                      role="menuitem"
                    >
                      <v-list-item-content>
                        <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.descricao }}<span v-if="item.externo" class="sr-only">, abre em nova aba</span></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <v-list-item v-else>
                    <v-list-item-content>
                      <v-list-item-title>Você não possui pendências no momento.</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col cols="2">
              <v-btn
                @click="pesquisa = !pesquisa"
                aria-label="Abrir busca"
                :aria-expanded="String(pesquisa)"
              >
                <v-icon>fa-solid fa-magnifying-glass</v-icon>
              </v-btn>
            </v-col>

            <!-- Pesquisar -->
            <v-col cols="12" v-if="pesquisa" role="search">
              <v-text-field
                @keyup.enter="buscar()"
                aria-label="Pesquisar no Nossa Hepta"
                autofocus
                v-model="keyword"
                dense
                solo
                hide-details="auto"
              >
                <template slot="label">
                  <span class="input-field-text">Pesquisar</span>
                </template>
                <template slot="append">
                  <v-btn icon x-small @click="buscar()" aria-label="Pesquisar">
                    <v-icon class="input-field-text"
                      >fa-solid fa-magnifying-glass</v-icon
                    >
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>

            <!-- Botão Espaço Colaborador -->
            <v-col cols="12" class="d-flex justify-center">
              <v-btn
                to="/espaco-do-colaborador"
                class="botao-espaco-colaborador w-100"
                >Espaço do Colaborador</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </div>

      <v-container class="py-0 hidden-sm-and-down">
        <div class="lista-links">
          <router-link to="/">
            <img
              src="../assets/images/icone/icone_hepta_com_nome.png"
              width="132px"
            />
          </router-link>
          <v-list height="84px" nav>
            <v-list-item
              v-for="item in menuItems"
              :key="item.id"
              :to="item.link"
              class="menu"
              active-class="menu_ativo"
            >
              {{ item.titulo }}
            </v-list-item>
          </v-list>
        </div>
      </v-container>
      <!-- Menu Mobile -->
      <v-navigation-drawer v-model="sidebar" absolute class="nav-drawer-mobile">
        <v-list>
          <v-list-item
            v-for="item in menuItems"
            :key="item.id"
            :to="item.link"
            >{{ item.titulo }}</v-list-item
          >
        </v-list>
      </v-navigation-drawer>
    </div>
  </div>
</template>

<script>
import modalMixin from "@/mixins/modalMixin";
import alerta from "@/components/Alerta.vue";
import api from "@/services/Api.js";

export default {
  components: { alerta },
  mixins: [modalMixin],
  data() {
    return {
      usuario: {},
      sidebar: false,
      subMenu: "Novidades",
      keyword: "",
      menuItems: [
        { titulo: "Início", link: "/", mobile: "true" },
        { titulo: "Novidades", link: "/novidades" },
        { titulo: "Recrutamento Hepta", link: "/vagas", mobile: "true" },
        { titulo: "#JeitoHepta", link: "/jeitohepta" },
        { titulo: "Biblioteca", link: "/biblioteca" },
        { titulo: "Perguntas Frequentes", link: "/perguntas-frequentes" },
      ],
      pesquisa: false,
      pendenciasColaborador: {},
      menuPendencias: false,
      menuPendenciasMobile: false,
    };
  },
  computed: {
    listaPendencias() {
      const p = this.pendenciasColaborador || {};
      const itens = [];

      if (p.termosAditivosPendentes > 0) {
        itens.push({
          titulo: "Termos e Condições",
          descricao: `Você possui ${p.termosAditivosPendentes} termos e condições para ciência à serem analisados`,
          rota: "Termos",
          externo: false,
        });
      }
      if (p.consentimentosPendentes > 0) {
        itens.push({
          titulo: "Consentimentos",
          descricao: `Você possui ${p.consentimentosPendentes} consentimentos à serem analisados`,
          rota: "Protecao de Dados",
          externo: false,
        });
      }
      if (p.visitasTecnicasPendentes > 0) {
        itens.push({
          titulo: "Visita Técnica",
          descricao: `Você possui ${p.visitasTecnicasPendentes} visitas que necessitam de atenção`,
          rota: "Visita Tecnica",
          externo: false,
        });
      }
      if (p.reciboFeriasPendentes > 0) {
        itens.push({
          titulo: "Recibo de Férias",
          descricao: `Você possui ${p.reciboFeriasPendentes} recibos de férias para assinar`,
          rota: "Ferias",
          externo: false,
        });
      }
      (p.treinamentosPendentes || []).forEach((treinamento) => {
        itens.push({
          titulo: treinamento.nome,
          descricao: "Treinamento pendente",
          link: treinamento.link,
          externo: true,
        });
      });

      return itens;
    },
    totalPendencias() {
      const p = this.pendenciasColaborador || {};
      return (
        (p.termosAditivosPendentes || 0) +
        (p.consentimentosPendentes || 0) +
        (p.visitasTecnicasPendentes || 0) +
        (p.reciboFeriasPendentes || 0) +
        (p.treinamentosPendentes ? p.treinamentosPendentes.length : 0)
      );
    },
    rotuloPendencias() {
      if (!this.totalPendencias) return "Pendências: nenhuma pendência no momento";
      return `Pendências: ${this.totalPendencias} ${this.totalPendencias == 1 ? "pendência" : "pendências"}`;
    },
  },
  watch: {
    menuPendencias(aberto) {
      if (aberto) this.focarPendencias("pendenciasDesktop");
    },
    menuPendenciasMobile(aberto) {
      if (aberto) this.focarPendencias("pendenciasMobile");
    },
  },
  methods: {
    getCredenciais() {
      let vm = this;
      api
        .get("auth/credenciais")
        .then((response) => {
          vm.usuario = response.data;
        })
        .catch((e) => {
          this.mensagemErro(e.message);
        });
    },
    buscar() {
      const currentPath = this.$route.path;
      const currentKeyword = currentPath.split("/pesquisa/")[1];

      // Ignorar caso em que a pesquisa é a mesma palavra ou não tenha nada escrito
      if (currentKeyword === this.keyword || !this.keyword) return;

      this.$router.push({ path: "/pesquisa/" + this.keyword });

      // Recarregar página se já estiver na pesquisa, para refazer as buscas
      if (currentPath.startsWith("/pesquisa/")) window.location.reload();
    },
    focarPendencias(ref, tentativas = 20) {
      requestAnimationFrame(() => {
        const lista = this.$refs[ref];
        const alvo = lista && lista.$el.querySelector('[role="menuitem"], .v-list-item');
        const visivel = alvo && alvo.getClientRects().length > 0;

        if (visivel) {
          alvo.focus();
        } else if (tentativas > 0 && (this.menuPendencias || this.menuPendenciasMobile)) {
          this.focarPendencias(ref, tentativas - 1);
        }
      });
    },
    navegarPendencias(evento) {
      const destinos = ["ArrowDown", "ArrowUp", "Home", "End"];
      if (!destinos.includes(evento.key)) return;

      const itens = [...evento.currentTarget.querySelectorAll('[role="menuitem"]')];
      if (!itens.length) return;

      evento.preventDefault();
      evento.stopPropagation();

      const atual = itens.indexOf(document.activeElement);
      const indice = {
        ArrowDown: (atual + 1) % itens.length,
        ArrowUp: (atual - 1 + itens.length) % itens.length,
        Home: 0,
        End: itens.length - 1,
      }[evento.key];
      itens[indice].focus();
    },
    abrirPendencia(item) {
      this.menuPendencias = false;
      this.menuPendenciasMobile = false;

      if (item.externo) {
        window.open(item.link, "_blank", "noopener");
        return this.focarSino();
      }
      if (this.$route.name === item.rota) return this.focarTitulo();
      this.$router.push({ name: item.rota }).then(() => this.focarTitulo(), () => {});
    },
    focarSino() {
      this.$nextTick(() => {
        const sinos = this.$el.querySelectorAll('.v-btn[aria-haspopup]');
        const sino = [...sinos].find((b) => b.getAttribute("aria-label") === this.rotuloPendencias && b.getClientRects().length);
        if (sino) sino.focus();
      });
    },
    focarTitulo(tentativas = 30) {
      requestAnimationFrame(() => {
        const titulo = document.querySelector("h1");

        if (titulo && titulo.getClientRects().length) {
          titulo.setAttribute("tabindex", "-1");
          titulo.focus();
        } else if (tentativas > 0) {
          this.focarTitulo(tentativas - 1);
        }
      });
    },
    nomeSobrenome() {
      if (this.usuario.nome) {
        let firstName = this.usuario.nome.split(" ")[0];
        let lastName = this.usuario.nome.split(" ").pop();
        return firstName + " " + lastName;
      }
    },
    logout() {
      const vm = this;
      api
        .get("auth/logout", {
          headers: { Authorization: localStorage.token },
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            localStorage.removeItem("isAdmin");
            localStorage.removeItem("isGpc");
            localStorage.removeItem("token");
            vm.$router.push({
              name: "Login",
            });
          }
        });
    },
    listarPendenciasColaborador() {
      const vm = this;
      api
        .get("headerDropDown/pendencias")
        .then((res) => {
          vm.pendenciasColaborador = res.data;
        })
        .catch((err) => {
          this.mensagemErro(err);
        });
    },
  },
  created() {
    this.getCredenciais();
    this.listarPendenciasColaborador();
  },
};
</script>

<style scoped>
.lista-links {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.lista-links .v-list {
  display: flex;
  padding: 0;
}

.lista-links .v-list-item {
  display: flex;
  justify-content: center;
  margin-bottom: 0 !important;
}

.lista-links .v-list-item:first-child {
  display: none;
}

.lista-links .v-list-item:hover {
  color: #278b97 !important;
}

.menu_ativo {
  border-bottom: 4px solid #278b97;
  border-radius: 0;
}

.menu_ativo::before {
  opacity: 0;
}

.topbar-mobile {
  background-color: #278b97;
}

.toolbar-mobile {
  display: flex;
  align-items: center;
}

.toolbar-mobile .v-btn {
  min-width: 32px !important;
  max-width: 100%;
  background-color: #278b97 !important;
  border: 1px solid #fff;
  border-radius: 8px;
}

.toolbar-mobile .v-icon {
  color: #fff;
  font-size: 1.125rem;
}

.notificacao-mobile {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -20px;
  right: -20px;
  width: 20px;
  height: 20px;
  font-size: 0.75rem;
  color: #fff;
  background: #db1826;
  border-radius: 50%;
}

.botao-espaco-colaborador {
  margin: auto !important;
  border: 1px solid #fff !important;
  font-weight: 600;
  width: 100%;
}

.botao-espaco-colaborador:hover {
  color: #32acb9 !important;
  background-color: #fff !important;
}

.nav-drawer-mobile {
  z-index: 99;
}

.container-appbar {
  display: contents;
}

.row-principal-appbar {
  align-items: center;
  margin: 0 5%;
}

.pesquisa {
  border-radius: 12px;
}

.pesquisa-label {
  color: #278b97;
  margin: 0 1rem;
}

.pesquisa-btn {
  margin-left: 1rem;
  min-width: 36px !important;
  width: 3rem;
  background-color: #32acb9 !important;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 8px;
}

.pesquisa-btn .v-icon {
  font-size: 1.25rem;
}

.header {
  border-radius: 0px;
  padding: 15px 0px 10px 100px;
  display: flex;
  gap: 25px;
}

.bemVindo {
  color: white;
  font-weight: bold;
}

.containerBemVindo {
  line-height: 20px;
}

.nomeUsuario {
  color: white;
  font-weight: normal;
}

.sair {
  color: white;
  font-weight: normal;
  font-size: 12px;
  cursor: pointer;
  background: none;
  border: 0;
  padding: 0;
  font-family: inherit;
  text-align: left;
  display: block;
  line-height: inherit;
}

.botao-header {
  min-width: 12px !important;
  width: 48px !important;
  height: 48px !important;
  background-color: #278b97 !important;
  border: 1px solid;
  border-color: #fff;
  border-radius: 8px;
  margin-right: 1rem;
}

.botao-header .v-icon {
  color: #fff;
  font-size: 1.125rem;
}

.notificacao {
  position: absolute;
  top: -25px;
  right: -26px;
  width: 23px;
  height: 23px;
  background: #db1826;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.pesquisar {
  width: 45% !important;
  margin-top: 2px;
  height: 50px;
  margin-left: 65px;
}

div.pesquisar.v-input__control {
  height: 40px !important;
}

.menu_header {
  border-radius: 0px;
  display: flex;
  gap: 25px;
}

.logoHepta {
  margin-left: 100px;
  height: 65px;
  margin-top: 5px;
}

.navegacao ul {
  list-style: none;
  padding: 0px 10px 9px 10px;
  background-color: rgb(255, 255, 255);
}

.navegacao ul li {
  display: inline;
}

.navegacao ul li a {
  color: black;
  text-decoration: none;
  display: inline-block;
  padding: 27px 25px 20px;
}

.activate {
  border-bottom: 1px solid;
  border-width: thick;
  border-color: #278b97;
  background-color: rgb(39 139 151 / 7%);
}

.subMenu {
  display: flex;
  margin-bottom: -20px;
}

.toolbar {
  display: flex;
  align-items: center;
  height: 84px;
}
</style>
